<template>
  <div id="admin-customer-list">
    <div class="row">
      <div class="col-12 mb-1">
        <h4 class="text-blue"><b><u>Customer List</u></b></h4>
      </div>
      <div class="col-12 mb-3">
        <b-form inline @submit.stop.prevent="getCustomer">
          <label class="mr-2" for="inline-form-custom-select-pref">From Date:</label>
          <b-form-input type="date" class="mr-2" v-model="form.fromDate"></b-form-input>
          <label class="mr-2" for="inline-form-custom-select-pref">To Date:</label>
          <b-form-input type="date" class="mr-2" v-model="form.toDate"></b-form-input>
          <b-button type="submit" variant="primary"><i class="fas fa-search"></i> Search</b-button>
        </b-form>
      </div>
      <div class="col-12">
        <div class="overflow-auto">
          <b-table bordered hover id="customer-table" :fields="fields" :items="items" :per-page="perPage"
            :current-page="currentPage" small show-empty>
            <template v-slot:cell(index)="data">
              <div class="text-center">{{ data.index + 1 }}</div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="col-12 text-right">
        <div class="float-right">
          <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage"
            aria-controls="customer-table">
          </b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
  export default {
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        fields: [{
            key: 'index',
            label: 'No.'
          },
          {
            key: 'firstName',
            label: 'First Name'
          },
          {
            key: 'lastName',
            label: 'Last Name'
          },
          {
            key: 'email',
            label: 'Email'
          },
          {
            key: 'mobile',
            label: 'Mobile'
          },
          {
            key: 'createDate',
            label: 'Create Date'
          },
          {
            key: 'updateDate',
            label: 'Update Date'
          }
        ],
        items: [],
        form: {
          fromDate: '',
          toDate: ''
        }
      }
    },
    mounted() {
      this.getCustomer()
    },
    methods: {
      getCustomer() {
        let loading = this.$loading.show()
        const formData = new FormData
        formData.append('fromDate', this.form.fromDate ? moment(this.form.fromDate).format('DD/MM/YYYY') : '')
        formData.append('toDate', this.form.toDate ? moment(this.form.toDate).format('DD/MM/YYYY') : '')
        formData.append('pageNo', 1)
        formData.append('pageSize', 999999999)
        formData.append('sortOrder', 'UpdateDate DESC')
        this.$http.post(this.$app.baseURL + this.$path.getCustomer, formData).then(
          res => {
            loading.hide()
            this.items = res.data.data
          }, () => {
            loading.hide()
          }
        )
      }
    }
  }
</script>

<style scoped>
  label#fromDate {
    border: none;
  }
</style>